import React from 'react'
import Popper from '@mui/material/Popper'
import Transitions from './transitions'
import Paper from '@mui/material/Paper'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import MainCard from './mainCard'
import CardContent from '@mui/material/CardContent'
import { useTheme } from '@mui/material/styles'

const PopperComponent = ({ open, anchorRef, handleClose, children, border, width, placement='bottom',offset=[0,9],portalSX={},zINdex=1500,sx,disablePortal=false,cardSX={}}) => {
    const theme = useTheme()
    return (
      <Popper
      disablePortal={disablePortal}
        sx={{ zIndex: 50,...portalSX}}
        open={open}
        anchorEl={anchorRef?.current ? anchorRef?.current : anchorRef}
        role={undefined}
        transition
        placement={placement}
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: offset
              }
            }
          ]
        }}
      >
        {({ TransitionProps }) => (
          <Transitions type="grow" position="top" in={open} {...TransitionProps}>
            <Paper
            aria-label='Popper'
              sx={{
                // boxShadow: theme.customShadows.z1,
                display: 'table',
                width: width ? width : 'fit-content',
                minWidth: 240,
                // minHeight:'250px',
                zIndex: zINdex,
                [theme.breakpoints.down('md')]: {
                  maxWidth: 250
                },
                borderRadius: 1.5,...sx
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard border={border ? true : false} content={false}>
                  <CardContent aria-label='Popper-Card-Content' sx={{ px: 2.5, pt: 3,...cardSX }}>
                    {children}
                  </CardContent>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    )
  }
  
  export default PopperComponent